import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=48ee2cc8"
import script from "./image-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-item.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./image-item.vue?vue&type=style&index=0&id=48ee2cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports